import { axios, AxiosResponse } from "@sdk/axios";
import { UserTracker } from "user-tracker";

import type {
  FlightSearchRequest,
  FlightSearchResponse,
  FlightSearchStatusResponse,
} from "./flight-search.models";

export class FlightSearchServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }

  constructor(protected config: { basePath: string; token: string }) {}

  async getFlightSearchStatus(): Promise<FlightSearchStatusResponse> {
    const results: AxiosResponse<FlightSearchStatusResponse> = await axios.get(
      this.config.basePath + `/flight-search/status`,
      {
        headers: {
          Authorization: this.config.token,
        },
      }
    );
    return results.data;
  }

  async searchFlights(
    request: FlightSearchRequest
  ): Promise<FlightSearchResponse> {
    UserTracker.track("Flight Search", {
      origin: request.origin,
      destination: request.destination,
      departureDate: request.departureDate,
      cabinClass: request.cabinClass,
    });

    const results: AxiosResponse<FlightSearchResponse> = await axios.post(
      this.config.basePath + `/flight-search/search`,
      request,
      {
        headers: {
          Authorization: this.config.token,
        },
      }
    );
    return results.data;
  }
}
